import './App.css';

function App() {
  return (
    <div className="App">
      <h1>Hello from the Armada network! </h1>
    </div>
  );
}

export default App;
